/**
 * The Pulpit: what the system answered over a window of days, read from the
 * audit log and nothing else.
 *
 * **Every number here is the core's own.** A decision, a reason and a provider
 * call are rows the core wrote, so nothing in this shape is a provider marking
 * its own homework — the same split `ProviderTraffic` draws for the health
 * screen. What a source says about itself stays on the health screen, and a
 * source added later appears here because it appears in `provider_call`, not
 * because anything was edited.
 *
 * Days are **Warsaw calendar days**, the calendar the registers and the
 * business keep. A UTC day would split an evening's orders across two bars.
 */
/** The windows the panel offers, in days, today included. */
export const DASHBOARD_WINDOWS = [7, 30, 90];
export const DEFAULT_DASHBOARD_WINDOW = 30;
/** A window somebody typed into a URL, read as one the panel offers — or the default. */
export function parseDashboardWindow(raw) {
    const parsed = Number(raw);
    return DASHBOARD_WINDOWS.includes(parsed)
        ? parsed
        : DEFAULT_DASHBOARD_WINDOW;
}
//# sourceMappingURL=dashboard.js.map